module.exports = __webpack_public_path__ + "static/media/redo.57c85aff.svg";